import React, { useState } from 'react';
import './LoginPage.css';

const LoginPage = ({ onLogin, onSignup, onBack }) => {
  const [isLoginView, setIsLoginView] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    if (isLoginView) {
      // Login
      if (!email || !password) {
        setError('Please fill in all fields');
        setIsLoading(false);
        return;
      }
      
      onLogin({ email, password });
    } else {
      // Signup
      if (!email || !password || !confirmPassword || !username) {
        setError('Please fill in all fields');
        setIsLoading(false);
        return;
      }
      
      if (password !== confirmPassword) {
        setError('Passwords do not match');
        setIsLoading(false);
        return;
      }
      
      onSignup({ email, password, username });
    }
    
    // Reset loading state after a delay to simulate API call
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  return (
    <div className="login-page">
      <div id="particles-js" className="particles-container"></div>
      
      <div className="login-content">
        <div className="logo-container">
          <div className="vd-logo">
            <div className="vd-square">
              <div className="vd-text">V</div>
              <div className="vd-text">D</div>
              <div className="vd-horizontal-line"></div>
              <div className="vd-vertical-line"></div>
            </div>
          </div>
          <div className="logo-text">VDEX</div>
        </div>
        
        <div className="auth-container">
          <button className="back-button" onClick={onBack}>
            ← Back to Home
          </button>
          
          <div className="auth-tabs">
            <button 
              className={`auth-tab ${isLoginView ? 'active' : ''}`}
              onClick={() => setIsLoginView(true)}
            >
              Login
            </button>
            <button 
              className={`auth-tab ${!isLoginView ? 'active' : ''}`}
              onClick={() => setIsLoginView(false)}
            >
              Sign Up
            </button>
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <form onSubmit={handleSubmit} className="auth-form">
            {!isLoginView && (
              <div className="form-group">
                <label>Username</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your username"
                  disabled={isLoading}
                />
              </div>
            )}
            
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                disabled={isLoading}
              />
            </div>
            
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                disabled={isLoading}
              />
            </div>
            
            {!isLoginView && (
              <div className="form-group">
                <label>Confirm Password</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm your password"
                  disabled={isLoading}
                />
              </div>
            )}
            
            <button 
              type="submit" 
              className="submit-button"
              disabled={isLoading}
            >
              {isLoading ? 'Processing...' : isLoginView ? 'Login' : 'Sign Up'}
            </button>
          </form>
          
          <div className="auth-footer">
            <p className="app-description">
              VDEX - Your Crypto Wallet. Secure. Beautiful. Powerful.
            </p>
            <p className="app-features">
              Manage and exchange your crypto securely from your desktop or mobile device.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
